import { useState } from "react";
import { Button } from "@volca/ui/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@volca/ui/components/ui/dialog";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { dayjs } from "@/core/utils/date";
import { CollapsibleSection } from "@/payroll/ai-script/ai-script-explanation-chat/collapsible-section";
import type {
  IPackChatSource,
  PackChatSourceAccess,
} from "@/payroll/pack-chat/types";
import { SourceStatement } from "./source-statement";

/** Sources identify a captured statement; the authorized route serves its current view. */
export const PackChatSource = ({
  source,
  access,
}: {
  source: IPackChatSource;
  access: PackChatSourceAccess;
}) => {
  const [open, setOpen] = useState(false);
  const captured = dayjs(source.captured_at).format("MMM D, YYYY, h:mm A");
  return (
    <CollapsibleSection label="Source">
      <Stack gap={1} align="start">
        <Text variant="caption" tone="muted">
          PayPack captured {captured}
        </Text>
        <Button
          variant="link"
          size="xs"
          className="h-auto px-0"
          onClick={() => setOpen(true)}
        >
          View source PayPack
        </Button>
      </Stack>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="flex h-[85dvh] flex-col overflow-hidden sm:max-w-2xl">
          <DialogHeader>
            <DialogTitle>Source PayPack</DialogTitle>
            <DialogDescription>
              AI used the statement captured {captured}. This view shows the
              statement available now. Later changes may differ from the AI
              source.
            </DialogDescription>
          </DialogHeader>
          <div className="min-h-0 flex-1">
            {open && <SourceStatement source={source} access={access} />}
          </div>
        </DialogContent>
      </Dialog>
    </CollapsibleSection>
  );
};
